<div class="padding flex column fix-height">
  <b class="margin-bottom-small">{{ data.title }}</b>

  <div class="flex center">
    <input type="text" class="flex-1" [(ngModel)]="searchFilter" (keyup.enter)="search()" />
    <button class="margin-left-smallest" (click)="search()">
      <i class="fa-solid fa-search margin-right-small"></i>
      Search
    </button>
  </div>

  @if (!data.singleSelection) {
    <div class="flex center between margin-top">
      <div class="grey">{{ datasourceSelected.length }} selected</div>

      <div class="flex center">
        <div class="margin-right-smallest hover primary" (click)="selectAll()">all</div>
        |
        <div class="margin-left-smallest hover primary" (click)="selectNone()">none</div>
      </div>
    </div>
  }

  @if (datasource.length && datasource.length >= 10) {
    <div class="fix-width flex center wrap margin-top-small gap">
      @for (element of datasourceSelected.slice(0, 4); track element.displayId) {
        <div class="filter-chip mini" [ngClass]="element.selected ? 'selected' : ''" (click)="onRemove(element)">
          {{ element.displayName }}
          <mat-icon class="hover small">close</mat-icon>
        </div>
      }
      @if (datasourceSelected.length > 4) {
        <div class="grey">+ {{ datasourceSelected.length - 4 }} others</div>
      }
    </div>
  }

  <div class="flex column margin-top-small flex-1 scrollable">
    @if (data.filterService.loading && !datasource.length) {
      <div class="flex column scrollable bg-light-grey center justify-center">
        <div class="flex center">
          <i class="fa-solid fa-circle-notch fa-2xl fa-spin"></i>
        </div>
      </div>
    } @else {
      @for (element of datasource; track element.displayId) {
        <div
          class="hover padding-small {{ element.selected ? 'bg-primary white' : 'bg-light-grey' }}"
          (click)="onClick(element)"
          inViewport
          (inViewportAction)="inViewportAction($event, element)"
        >
          {{ element.displayName }}
        </div>
      }
      @if (data.filterService.loading && datasource.length) {
        <div class="flex center padding-small">
          <i class="fa-solid fa-circle-notch fa-spin"></i>
        </div>
      }
    }
  </div>

  <div class="flex column end margin-top-small">
    <div class="flex center">
      <button class="stroked margin-right-small" (click)="onClose()">
        <i class="fa-solid fa-rotate-left margin-right-small"></i>
        Discard
      </button>
      <button [mat-dialog-close]="datasourceSelected" cdkFocusInitial>
        <i class="fa-solid fa-check margin-right-small"></i>
        Apply
      </button>
    </div>
  </div>
</div>
